import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: null,
};

export const authenticationSlice = createSlice({
  name: "authentication",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      const { user } = action.payload;
      state.isAuthenticated = true;
      state.user = user;
    },
    clearAuth: () => initialState,
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const selectIsAuthenticated = (state) =>
  state.authentication.isAuthenticated;

// A stable empty user so components that read user fields never crash on a
// transient null (e.g. a brief moment during sign-in or a re-auth). Returning a
// constant reference avoids needless re-renders.
const EMPTY_USER = {
  id: null,
  externalId: null,
  username: null,
  emailAddress: null,
  imageUrl: null,
};
export const selectUser = (state) => state.authentication.user || EMPTY_USER;

export const { setAuth, clearAuth, setUser } = authenticationSlice.actions;

export default authenticationSlice.reducer;
